export default __webpack_public_path__ + "media/images/main/arrow-grey-8da2578da3a12bf1fcbbab109481c210.png";